import { useTranslation } from 'react-i18next';
import {
  CONSENT_OVERVIEW_FILTER,
  type ConsentOverviewFilter,
} from '@/api/consents/consentsApi.types';
import { cn } from '@/lib/utils';

interface ConsentOverviewFiltersProps {
  value: ConsentOverviewFilter;
  onChange: (nextValue: ConsentOverviewFilter) => void;
}

const FILTER_OPTIONS: { value: ConsentOverviewFilter; labelKey: string }[] = [
  { value: CONSENT_OVERVIEW_FILTER.all, labelKey: 'overview.filter.all' },
  { value: CONSENT_OVERVIEW_FILTER.pending, labelKey: 'overview.filter.pending' },
  {
    value: CONSENT_OVERVIEW_FILTER.needsReacceptance,
    labelKey: 'overview.filter.needsReacceptance',
  },
];

export function ConsentOverviewFilters({ value, onChange }: ConsentOverviewFiltersProps) {
  const { t } = useTranslation('consents');
  return (
    <div className="inline-flex flex-wrap bg-zoowhite border border-zooborder rounded-xl p-1 self-start">
      {FILTER_OPTIONS.map(function renderOption(option) {
        const isOn = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={isOn}
            onClick={function select() {
              onChange(option.value);
            }}
            className={cn(
              'px-4 py-2 rounded-lg text-xs font-bold transition-colors',
              isOn ? 'bg-zooprimary text-zoowhite' : 'text-zoomuted'
            )}
          >
            {t(option.labelKey)}
          </button>
        );
      })}
    </div>
  );
}
